import {baseEnvironment, misBaseURL} from './environment.base';

export const serviceNowUrl = 'https://amdocsprodmain.service-now.com';

export const environment = Object.assign(baseEnvironment, {
  serviceNowBaseUrl: serviceNowUrl,
  loginGWBaseURL: `${misBaseURL}/cas`,
  cnsBaseURL: `${misBaseURL}/cns/graphql`,
  imgUrl: `${misBaseURL}/sas/profilePicture`,
  startChatURL: `${serviceNowUrl}/ta?id=ta_it_chat&origin=clic`,
  serviceNowURL: `${serviceNowUrl}/ta?origin=clic`,
  reportAnIssueUrl: `${serviceNowUrl}/ta?id=ta_sc_cat_item&sys_id=e444b00cdb4b6090a258e1aa4b9619a8&origin=clic`,
  production: true,
  allowMimic: false,
  bot: {
        id: 'mis-navigator-prod',
        name: 'mis-navigator-prod'
    },
  imgVersion: '3',
  isMaintenance: false,
  isCarWashUnavailable : true,
  LEARNING_PORTAL: 'https://learning.mis.amdocs.com',
  carWashTiming : 12,
  enableLogging: false,
});

